import React from 'react';

const ActionHeader = ({ title, claimNumber }) => {   
 
    return (
        <div className="grid gutter tight collapse840">
            <div className="col s8of12">
                <h2>{title}</h2>
            </div>
            {claimNumber && <div className="col s4of12 text-right text-14">
                {claimNumber}
            </div>}
        </div>
      );
};

export default ActionHeader;
